import { CustomCol, ColStyles } from './col.styles'

interface ColProps extends ColStyles {
  children?: any
  gap?: any
  flex?: string
}

export const Col = ({
  children,
  justifyContent,
  alignItems,
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  gap,
  flex
}: ColProps) => (
  <CustomCol
    justifyContent={justifyContent}
    alignItems={alignItems}
    marginTop={marginTop}
    marginBottom={marginBottom}
    marginLeft={marginLeft}
    marginRight={marginRight}
    gap={gap}
    flex={flex}
  >
    {children}
  </CustomCol>
)
